RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.Reports = window.createMarionetteApp();
    app.name = 'Reports';
});
